import styled from 'styled-components';
import { Form } from 'formik';
import Icon from '@minecraft.icon';
import { media } from '@minecraft.themes';
import { FormItem } from '../../shared/styles';

export const StyledForm = styled(Form)`
  display: flex;
  flex-direction: column;
  position: relative;
  min-width: 15rem;
  min-height: 15rem;
`;

export const FilterOverlayContent = styled.div`
  z-index: 100;
  height: 100%;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  display: inline-flex;
  flex-direction: column;
  padding: 0 1rem;
  background-color: ${(props): string => props.theme.filters.overlay.backgroundColor};
  border: 1px solid ${(props): string => props.theme.filters.overlay.borderColor};
  border-radius: 0.25rem;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
  overflow: auto;

  ${media.sm`
    width: auto;
    height: auto;
    position: absolute;
    top: 2rem;
    border-radius: 0.125rem;
    overflow: unset;
  `}

  ${FormItem} {
    max-width: 100%;
  }
`;

export const FilterOverlayContentHeader = styled.div`
  color: ${(props): string => props.theme.filters.color};
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.5rem;
  padding: 1.5rem 0;
  border-bottom: 1px solid ${(props): string => props.theme.colors.accent.ltGrey4};

  h3 {
    margin: 0;
    color: inherit;
  }
`;

export const FilterOverlayContentBody = styled.div`
  position: relative;
  padding-top: 1.5rem;
  padding-bottom: 0.9375rem;
  margin-top: 0.5rem;
`;

export const ButtonGroup = styled.div`
  & > * {
    width: 100%;
    font-size: 1rem;
    height: 2.5rem;

    ${media.sm`
      font-size: 0.875rem;
      height: 2rem;
    `}

    &:not(:last-child) {
      margin-bottom: 1rem;
    }
  }
`;

export const CloseIcon = styled(Icon)`
  cursor: pointer;
  height: 1.375rem;
  width: 1.375rem;
`;
